import { WEBCOIN_SECTIONS } from '@wwe-portal/web/utils/constants/webcoin';
import { useTranslations } from 'next-intl';

import { Each } from '@wwe-portal/ui/components/utils';
import { OfferData } from '@wwe-portal/entities/offer.type';
import { OfferCard } from '../../offer-card/offer-card';

export const DailyWebCoinListDesktop = ({
  ref,
  pacificDate,
  handleUpdateLiveList,
  handlePurchaseDailyWebCoinOffer,
  purchasingOffer,
  webCoinDailyOffers,
}: {
  ref: React.RefObject<HTMLDivElement | null>;
  pacificDate: string;
  handleUpdateLiveList: () => void;
  handlePurchaseDailyWebCoinOffer: (
    data: OfferData,
    offerType: string,
    e: any
  ) => void;
  purchasingOffer: any;
  webCoinDailyOffers: OfferData[];
}) => {
  const t = useTranslations();

  return (
    <div id={WEBCOIN_SECTIONS.DAILY_WEBCOIN_OFFERS}>
      <div
        ref={ref}
        className="shop-featured mb-[10px] flex justify-between pt-[30px]"
      >
        <div className="mb-0 text-xl font-semibold">
          {t('daily_web_coin_offers')}
        </div>
      </div>
      <p className="text-text600 mb-8 text-xs">
        {t('daily_web_coin_offers_description')}
      </p>
      <div className="-mr-[10px] flex flex-wrap justify-start">
        <Each
          data={
            webCoinDailyOffers?.filter(
              (offer: OfferData) => offer.StockQuantity
            ) ?? []
          }
          render={(item: OfferData, index) => (
            <div
              key={index}
              className="3xl:basis-1/5 mb-[30px] pr-4 md:basis-1/2 2xl:basis-1/3"
            >
              <div
                key={item.OffersID}
                className="mb-[30px]"
                data-id="web-coin-daily-offers"
              >
                <OfferCard
                  hasWebCoinPrice
                  offerType="daily"
                  transactionStarted={purchasingOffer?.offerId}
                  onHandlePurchase={(data, e) =>
                    handlePurchaseDailyWebCoinOffer(data, 'daily', e)
                  }
                  offer={item}
                  index={index}
                />
              </div>
            </div>
          )}
        />
      </div>
    </div>
  );
};
